module.exports = __webpack_public_path__ + "static/hero-background-4f180e70b35f40d14a6ad95fbd0de38d.png";